import { useEffect, useId, useRef } from 'react'

import { useMinimizedModalsContext } from '../useMinimizedModalsContext'

// Makes a non-minimizable host (e.g. an open inline reply form) visible to
// `confirmBeforeAction`, so navigation-style actions that would unmount it
// prompt while it is dirty.
export function useMinimizedModalsDirtyGuard({
  getIsDirty,
  isEnabled,
  leaveConfirmation,
  scope,
}) {
  const { registerDirtyGuard, unregisterDirtyGuard } =
    useMinimizedModalsContext()

  const guardKey = useId()

  const getIsDirtyRef = useRef(getIsDirty)

  useEffect(() => {
    getIsDirtyRef.current = getIsDirty
  })

  useEffect(() => {
    if (isEnabled) {
      registerDirtyGuard(guardKey, {
        getIsDirty: () => getIsDirtyRef.current?.(),
        leaveConfirmation,
        scope,
      })

      return () => unregisterDirtyGuard(guardKey)
    }
  }, [isEnabled, scope])
}
